import React from 'react';
import { motion } from 'framer-motion';

const TermsPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 px-6">
      <div className="max-w-[1000px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <h1 className="font-heading text-5xl font-bold text-text-primary mb-4">
            Termos de Uso
          </h1>
          <p className="text-lg text-text-secondary">
            Informações importantes sobre o uso da loja Aura Rosa.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10 space-y-8 text-lg text-text-secondary leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl font-bold text-text-primary mb-3">
              1. Uso da loja
            </h2>
            <p>
              Ao acessar a Aura Rosa, o usuário concorda em utilizar a loja de forma adequada,
              respeitando a legislação vigente e as condições aqui apresentadas.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold text-text-primary mb-3">
              2. Produtos e informações
            </h2>
            <p>
              Buscamos manter todas as informações, imagens e descrições dos produtos atualizadas,
              mas pequenos ajustes podem ocorrer sem aviso prévio.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold text-text-primary mb-3">
              3. Pagamentos e pedidos
            </h2>
            <p>
              Os pagamentos são processados por meios seguros e os pedidos ficam sujeitos à confirmação
              de pagamento e disponibilidade dos itens.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold text-text-primary mb-3">
              4. Contato
            </h2>
            <p>
              Em caso de dúvidas, o cliente poderá entrar em contato pelos canais oficiais informados na loja.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;